import { render } from "./relink-alert.vue?vue&type=template&id=290c8048&lang=pug"
import script from "./relink-alert.vue?vue&type=script&lang=js"
export * from "./relink-alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__